// removed by extract-text-webpack-plugin
module.exports = {"container":"ModuleLoadingSpinner__container__2kwec","progress":"ModuleLoadingSpinner__progress__2HViO","icon":"ModuleLoadingSpinner__icon__2F9JX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ModuleLoadingSpinner/ModuleLoadingSpinner.css
// module id = 508
// module chunks = 0